import SalaryCard from "./SalaryCard";
import EarnerCard from "./EarnerCard";
import useTranslator from "../../hooks/useTranslator";
import CloseIcon from "../../assets/img/closeIcon.svg";
import { useContext, useEffect, useState } from "react";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
const TotalSalaryModal = ({
  isOpen,
  onClose,
  handleUpdateSource,
  effortObj,
  userIncome,
  user,
  gurantorsIncome = [],
  setUpdateSourceObj,
  showReportIcons = true,
  llShowOnly,
  disabledIncomeSourcesFromDb = [],
  profileId,
  loadFullInfo,
  isFromReport,
}) => {
  const { _t } = useTranslator();
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [disabledIncomeSources, setDisabledIncomeSources] = useState([]);
  const { user: originalUser } = useContext(AuthContext);
  const { disableIncomeSource } = useContext(LandLordContext);
  const [updateSourceLoading, setUpdateSourceLoading] = useState(false);

  const toggleIncomeSource = (id) => {
    setDisabledIncomeSources((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    setDisabledIncomeSources(disabledIncomeSourcesFromDb);
  }, []);

  const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((id) => arr2.includes(id));
  };

  const hasChanges = !arraysEqual(
    disabledIncomeSources,
    disabledIncomeSourcesFromDb
  );

  const handleUpdateIncomeSources = async () => {
    const payload = {
      profileOf: "sharedprofile",
      // profileOf: originalUser?.isParentLL ? "agency" : "sharedprofile",
      incomeSources: disabledIncomeSources,
    };
    setUpdateSourceLoading(true);
    disableIncomeSource(profileId, payload)
      .then((res) => {
        loadFullInfo();
      })
      .catch(() => {
        console.log("Failed to income source at in profile");
      })
      .finally(() => {
        setUpdateSourceLoading(false);
      });
  };

  if (!isOpen) return;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="drawerIcon" onClick={onClose} />
        <div className="doc-history-header">
          <img
            src={CloseIcon}
            alt=""
            className="doc-history-close-btn"
            onClick={onClose}
          />
          <h4 className="custom-modal-heading">{_t("totalSalary")}</h4>
        </div>
        <SalaryCard effortObj={effortObj} />
        <div className="total-earners-wrapper">
          <h4>{_t("totalEarners")}</h4>
          <span className="earner-count">
            {(user?.gurantor_id?.length ?? 0) + 1}
          </span>
        </div>
        <div
          className={`earner-card-wrapper ${
            llShowOnly && hasChanges
              ? "dynamic-height"
              : "dynamic-mobile-height"
          }`}
        >
          {
            <EarnerCard
              handleUpdateSource={handleUpdateSource}
              userData={userIncome}
              type="tenant"
              setUpdateSourceObj={setUpdateSourceObj}
              allowViewProfile={false}
              showReportIcons={showReportIcons}
              user={user}
              toggleIncomeSource={toggleIncomeSource}
              isEnabled={
                !disabledIncomeSources.includes(userIncome?.all_sources?._id)
              }
              showIncomeSourceSelector={llShowOnly && !isFromReport}
              llShowOnly={llShowOnly}
            />
          }
          {gurantorsIncome.map((data) => (
            <EarnerCard
              handleUpdateSource={handleUpdateSource}
              userData={data}
              type="guarantor"
              setUpdateSourceObj={setUpdateSourceObj}
              onClose={onClose}
              showReportIcons={showReportIcons}
              isDropdown={activeDropdownId === data?.all_sources?._id}
              setIsDropdown={() =>
                setActiveDropdownId(
                  activeDropdownId === data?.all_sources?._id
                    ? null
                    : data?.all_sources?._id
                )
              }
              toggleIncomeSource={toggleIncomeSource}
              isEnabled={
                !disabledIncomeSources.includes(data?.all_sources?._id)
              }
              showIncomeSourceSelector={llShowOnly && !isFromReport}
              llShowOnly={llShowOnly}
            />
          ))}
        </div>
        {llShowOnly && hasChanges && (
          <div className="addGuarantorButtonWrapper d-flex align-items-center justify-content-center">
            <button
              className="btnNext addGuarantorButton d-flex align-items-center justify-content-center"
              disabled={updateSourceLoading}
              onClick={handleUpdateIncomeSources}
            >
              {_t("updatedIncomeSources")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalSalaryModal;
